<template>
    <div class="uploadBox">
        <el-upload class="upload-demo" drag action="/" :http-request="pushUp" :show-file-list="false">
            <slot name="icon">
                <!--                <i class="iconfont cardIcon">&#xe68d;</i>-->
            </slot>
            <slot name="tips">
                <!--                <div class="el-upload__text">将照片拖到此处，或<em>点击上传</em></div>-->
            </slot>
        </el-upload>
    </div>
</template>

<script>
    export default {
        name:"upload",
        methods:{
            pushUp(fileObj){
                this.$emit("loadFile", fileObj.file)
                // console.log(fileObj.file)
            }
        }
    }
</script>

<style>
    .uploadBox{
        width: 100%;
        text-align: center;
        position: relative;
    }
    .el-upload-dragger{
        width: 940px;
        min-height: 400px;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .cardIcon{
        color: #eee;
        font-size: 300px;
    }
    .el-upload-dragger:hover{
        border-color: #d82a22;
    }
    .el-upload:focus .el-upload-dragger{
        border-color: #d82a22;
    }
    .el-upload-dragger .el-upload__text em{
        color: #d82a22;
    }
</style>
